
import { HttpAddressesList} from '@/service/basicdata';
import TableList from "@components/templates/tablelist";

import comIndex from './update'
import { mapGetters } from 'vuex';

export default {
    mixins: [TableList],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            addressCodeList:[],
            formData: {
                search: {
                },
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            title:"",
            entitle:"",
            Plugins: { show: true },
        };
    },
    created() {
      },
    methods: {
        ajaxRequest: HttpAddressesList,
       
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t( 'erp.product.new_add', { defaultValue: '添加' }),
                        show:true,
                        width:800,
                        component: "comIndex",
                        type:'add',
                        showFooter:false,
                    }
                    break;    
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show:true,
                        width:800,
                        component: "comIndex",
                        activeid:params,
                        type:'query',
                        showFooter:false,
                    }
                    break;          
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show:true,
                        width:800,
                        component: "comIndex",
                        activeid:params,
                        type:'edit',
                        showFooter:false,
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show:true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show:true,
                params: id,
                operate: 'edit'
            }
          ]
        },
        
    },
    computed: {
        ...mapGetters('dictionary', ['getSystemPortList']),
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: "添加" }),
                operate: "add",
                theme: "primary",
            }]
        },
        SearchsData() {
            return [{
                    label: this.$t('fbb.basic.gateshop_code', { defaultValue: '地址code' }),
                    key: 'EQ_code',
                    tag: 'vInput',
                    show: true,
                }
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 90,
                    render: this.getOperateNodes
                },{
                    title: this.$t('fbb.basic.gateshop_code', { defaultValue: '地址code' }),
                    key: 'code',
                }, {
                    title: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key: 'country',
                }, {
                    title: this.$t('erp.b2c.state_province', { defaultValue: '州' }),
                    key: 'state',
                }, {
                    title: this.$t('erp.b2c.city', { defaultValue: '城市' }),
                    key: 'city',
                }, {
                    title: this.$t('erp.b2c.zip_code', { defaultValue: '邮编' }),
                    key: 'postal',
                }, {
                    title: this.$t('fbb.accountmanage.description', { defaultValue: '描述' }),
                    key: 'description',
                }];
        },
    },
};




